import { css } from '@linaria/core';
import AnalyticsPoint from 'gatsby-plugin-purina-analytics/AnalyticsPoint';
import * as React from 'react';
import Link from '../Link';
import MediaVectorImage from '../media/MediaVectorImage';

interface ParagraphProps extends Paragraph {
  link: LinkProps;
  relationships: {
    media?: MediaVectorImage;
  };
}

interface ParagraphLinkedLogoProps {
  node: ParagraphProps;
}

// create new class to logo using cx.
const logoClass = css`
  .search-visible & {
    display: none;
  }
`;

const ParagraphLinkedLogo: React.FC<ParagraphLinkedLogoProps> = function ({ node }) {
  const [isFrench, setIsFrench] = React.useState(false);

  const { link } = node;
  const media = node.relationships?.media;
  const logo = media?.relationships.svg?.url;
  const alt = media?.svg?.alt || '';

  React.useEffect(() => {
    setIsFrench(/^\/fr(\/|$)/.test(window.location.pathname));
  }, []);

  if (logo) {
    return (
      <AnalyticsPoint
        type="module"
        typeLabel="site_navigation"
        label="site navigation"
        as="div"
        className={logoClass}
        style={{ width: isFrench ? '200px' : '150px', marginRight: 'auto' }}
      >
        <AnalyticsPoint
          type="component"
          typeLabel="home_logo"
          label="Home logo"
          eventLabel="Home logo"
          action="logo click"
        >
          <Link to={link.url} {...link?.options?.attributes} aria-current={undefined}>
            <img src={logo} alt={alt} className="logo" />
          </Link>
        </AnalyticsPoint>
      </AnalyticsPoint>
    );
  }

  return null;
};

export default ParagraphLinkedLogo;
